import { SourceDocument } from '../types/assessment'

export const sourceDocuments: SourceDocument[] = [
  {
    id: 'STMT-2026-04',
    title: 'Bank Statement — April 2026',
    kind: 'Bank Statement',
    issuer: 'Banque Postale · Meridian SAS — Operating EUR · IBAN FR76 0000 0000 0000 0000 0000 000',
    body: [
      'ACCOUNT: Meridian SAS — Operating EUR',
      'PERIOD: 01 Apr 2026 – 30 Apr 2026',
      'OPENING BALANCE: 2,418,330.12 EUR',
      '',
      '03 APR  SEPA-88123  NORDCLOUD SERVICES OY            -18,400.00',
      '11 APR  SEPA-88198  BRAUER HANDEL GMBH               +96,250.00',
      '18 APR  SEPA-88244  VERNIER AUDIT SARL               -27,500.00',
      '24 APR  SEPA-88301  NORDIKA HLDGS SAS                -45,000.00',
      '        Remittance advice: "Settlement of April',
      '        supplier balance — group entity FR"',
      '',
      'MOVEMENT FOR PERIOD:                                  +5,350.00',
      'CLOSING BALANCE: 2,423,680.12 EUR',
    ],
  },
  {
    id: 'STMT-2026-0506',
    title: 'Bank Statement — May / June 2026',
    kind: 'Bank Statement',
    issuer: 'Banque Postale · Meridian SAS — Operating EUR · IBAN FR76 0000 0000 0000 0000 0000 000',
    body: [
      'ACCOUNT: Meridian SAS — Operating EUR',
      'PERIOD: 01 May 2026 – 30 Jun 2026',
      'OPENING BALANCE: 2,423,680.12 EUR',
      '',
      '02 MAY  SEPA-88377  MERIDIAN SAS PAYROLL            -212,800.00',
      '14 MAY  SEPA-88420  VANDERMEER RETAIL BV            +148,000.00',
      '21 MAY  SEPA-88468  PALAIS EVENEMENTS SA             -16,300.00',
      '        Note: deposit reduced by 450.00 credit note',
      '04 JUN  SEPA-88512  DGFIP TVA                        -84,900.00',
      '19 JUN  SEPA-88566  LINDQVIST TAX ADVISORY AB        -31,200.00',
      '27 JUN  SEPA-88618  HARBOURLINE GROUP PTY            +52,400.00',
      '',
      'MOVEMENT FOR PERIOD:                                -144,800.00',
      'CLOSING BALANCE: 2,278,880.12 EUR',
    ],
  },
  {
    id: 'INV-4471',
    title: 'Supplier Invoice — Nordika Systems AB',
    kind: 'Invoice',
    issuer: 'Nordika Systems AB · Kungsgatan 12, Stockholm · VAT SE556123456701',
    body: [
      'BILL TO: Meridian SAS, France',
      'INVOICE: INV-4471   DATE: 02 Apr 2026   DUE: 24 Apr 2026',
      '',
      'Integration engineering retainer, April 2026 ........ 45,000.00 EUR',
      'VAT: reverse charge (Art. 196 EU VAT Directive)',
      'TOTAL DUE: 45,000.00 EUR',
      '',
      'REMIT TO: Nordika Systems AB',
      'IBAN SE35 5000 0000 0549 1000 3123',
      '',
      'NOTE: Nordika Systems AB is a separate legal entity from',
      'Nordika Holdings SAS (France). Do not net balances between',
      'the two counterparties.',
    ],
  },
  {
    id: 'INV-4472',
    title: 'Supplier Invoice — Vernier Audit SARL',
    kind: 'Invoice',
    issuer: 'Vernier Audit SARL · 8 quai du Rhône, Lyon · VAT FR40123456824',
    body: [
      'BILL TO: Meridian SAS, France',
      'INVOICE: INV-4472   DATE: 10 Apr 2026   DUE: 18 Apr 2026',
      '',
      'Interim statutory audit fieldwork ................... 27,500.00 EUR',
      'TOTAL DUE: 27,500.00 EUR',
    ],
  },
  {
    id: 'INV-4468',
    title: 'Customer Invoice — Brauer Handel GmbH',
    kind: 'Invoice',
    issuer: 'Meridian SAS → Brauer Handel GmbH · Germany',
    body: [
      'ISSUED BY: Meridian SAS, France',
      'BILL TO: Brauer Handel GmbH, Germany',
      'INVOICE: INV-4468   DATE: 08 Apr 2026   DUE: 11 Apr 2026',
      '',
      'Q2 2026 subscription fee,',
      'April–June service period .......................... 96,250.00 EUR',
      'TOTAL DUE: 96,250.00 EUR',
    ],
  },
  {
    id: 'SCH-2026-Q1',
    title: 'Q1 Accruals Schedule',
    kind: 'Schedule',
    issuer: 'Meridian SAS · Accrued liabilities at 31 March 2026 — extract',
    body: [
      'ACCRUED LIABILITIES AT 31 MARCH 2026 — EXTRACT',
      '',
      'Lindqvist Tax Advisory AB — transfer pricing advisory,',
      'engagement LTA-114 ................................. 31,200.00',
      '        release on receipt of final invoice',
      '',
      'Vernier Audit SARL — audit fee accrual ..................... 0.00',
      '        (billed to date)',
      '',
      'Office lease service charge true-up .................. 6,150.00',
      '',
      'Releases are posted by entity controllers on settlement.',
      'Unreleased balances at Q2 close must be justified.',
    ],
  },
  {
    id: 'MEMO-2026-11',
    title: 'Group Reporting Memo — Q1 Comparatives',
    kind: 'Memo',
    issuer: 'Meridian Group Consolidation · Internal',
    body: [
      'TO: Entity controllers (FR, DE, NL, SE)',
      'SUBJECT: Comparative figures used in the Q2 reporting pack',
      '',
      'The Q2 pack draws prior-period comparatives from the group',
      'consolidation extract dated 12 May 2026, not from the Q1',
      'statutory pack issued 30 Apr 2026.',
      '',
      'Where a cut-off adjustment was processed after the Q1 pack was',
      'issued, the comparative column will differ from the published',
      'Q1 figure. Such movements are not separately disclosed in the',
      'Q2 pack, and controllers are expected to agree comparatives',
      'back to the published statutory figures before signing off',
      'variances.',
      '',
      'Q1 statutory pack, published figures (extract):',
      '  Revenue — Subscriptions .................. 1,248,000.00 EUR',
      '  Revenue — Services ......................... 208,500.00 EUR',
      '  Payroll & Benefits ........................ (612,400.00) EUR',
    ],
  },
]

export const documentOptions = [
  ...sourceDocuments.map((d) => ({ id: d.id, label: `${d.id} — ${d.title}` })),
  { id: 'JUDGEMENT', label: 'Professional judgement / not in pack' },
]
